import _DTO from "./_DTO";
import DeviceDTO from "./DeviceDTO";
import RangeInfoDTO from "./RangeInfoDTO";
import IOIslandDTO from "./IOIslandDTO";
import ConfigurationAccessoriesDTO from "./ConfigurationAccessoriesDTO";
import PowerSupplyManagementDTO from "./PowerSupplyManagementDTO";
import RackDTO from "./RackDTO";
import UserChannelsDTO from "./UserChannelsDTO";
import SoftwareLicenceDTO from "./SoftwareLicenceDTO";
import RedBoxDTO from "./RedBoxDTO";
import TerminalBlockPreferencesDTO from "./TerminaBlockPreferencesDTO";
import SoftwareLicenseSelectionDTO from "./SoftwareLicenseSelectionDTO";


export default class ConfigurationDTO extends _DTO {

  constructor(configuration) {
    super();
    this.id = configuration.id;
    this.name = configuration.name;
    this.status = configuration.status;
    this.headModule = ConfigurationDTO.getMappedOrDefault(configuration, 'headModule', null, data => new DeviceDTO(data));
    this.rack = ConfigurationDTO.getMappedOrDefault(configuration, 'rack', null, data => data ? new RackDTO(data) : null);
    this.rangeInfo = ConfigurationDTO.getMappedOrDefault(configuration, 'rangeInfo', null, data => new RangeInfoDTO(data));
    this.ioModules = ConfigurationDTO.getMappedOrDefault(configuration, 'ioModules', [], data => data.map(d => new DeviceDTO(d)));
    this.comModules = ConfigurationDTO.getMappedOrDefault(configuration, 'comModules', [], data => data.map(d => new DeviceDTO(d)));
    this.cartridges = ConfigurationDTO.getMappedOrDefault(configuration, 'cartridges', [], data => data.map(d => new DeviceDTO(d)));
    this.ioIslands = ConfigurationDTO.getMappedOrDefault(configuration, 'ioIslands', [], data => data.map(i => new IOIslandDTO(i)));
    this.localRacks = ConfigurationDTO.getMappedOrDefault(configuration, 'localRacks', [], data => (data || []).map(c => new ConfigurationDTO(c)));
    this.redboxes = ConfigurationDTO.getMappedOrDefault(configuration, 'redboxes', [], data => (data || []).map(r => new RedBoxDTO(r)));
    this.softwareSelection = configuration.softwareSelection;
    this.softwareLicences = ConfigurationDTO.getMappedOrDefault(configuration, 'softwareLicences', [], data => data.map(s => new SoftwareLicenceDTO(s)));
    this.licenseModel = configuration.licenseModel;
    this.servicePlanActivated = configuration.servicePlanActivated;
    this.showPrecommercializedProducts = configuration.showPrecommercializedProducts;
    this.step = configuration.step;
    this.starterType = configuration.starterType;
    this.configurationType = configuration.configurationType;
    this.senderEmail = configuration.senderEmail;
    this.senderName = configuration.senderName;
    this.softwareVersion = configuration.softwareVersion;
    this.accessories = ConfigurationDTO.getMappedOrDefault(configuration, 'accessories', new ConfigurationAccessoriesDTO({}), data => new ConfigurationAccessoriesDTO(data));
    this.host = configuration.host;
    this.country = configuration.country;
    this.powerSupplyManagement = ConfigurationDTO.getMappedOrDefault(configuration, 'powerSupplyManagement', null, data => new PowerSupplyManagementDTO(data));
    this.customOutputConsumption = ConfigurationDTO.getOrDefault(configuration, 'customOutputConsumption', 0);
    this.userChannels = ConfigurationDTO.getMappedOrDefault(configuration, 'userChannels', null, data => data ? new UserChannelsDTO(data) : null);
    this.campaignId = configuration.campaignId;
    this.internal = configuration.internal;
    this.urlParams = configuration.urlParams;

    this.terminalBlockPreferences = ConfigurationDTO.getMappedOrDefault(configuration, 'terminalBlockPreferences', null, data => data ? new TerminalBlockPreferencesDTO(data) : null);

    this.softwareLicenseSelections =  ConfigurationDTO.getMappedOrDefault(configuration, 'softwareLicenseSelections', [], data => (data || []).map(s => new SoftwareLicenseSelectionDTO(s)));
    const allSeenSteps = ConfigurationDTO.getMappedOrDefault(configuration, 'seenSteps', [], data => {
      try {
        return (data || []).map(s => s);
      } catch(e) {}
      return [];
    });
    // Remove eventual duplicates from the seen steps.
    this.seenSteps = allSeenSteps.filter((item,index) => allSeenSteps.indexOf(item) === index);
  }
}
